/* eslint-disable */
import React, {useEffect, useState} from 'react'
import { useLocation, useHistory } from "react-router-dom";
import moment from 'moment';
// import _ from 'lodash';
import Divider from "components/Divider";
// servicess
// import manageChannelManagement from 'services/managementChannelSvc';
import applicationSvc from 'services/applicationSvc';
import authSvc from "services/authSvc";
import userSvc from "services/userSvc";
import { channelConstant } from "_constant";
// components
import BreadCrumb from 'components/BreadCrumb';
import { Alert } from 'utils/Alert';
import TextInput from 'components/TextInput';
// import Table from './TableData'

// style
import './detailApp.scss';

function EditAppNew() {
  const [isDataDetail, setDataDetail] = useState()
  // const [loadingGenerate, SetLoadingGenerate] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [user, setUser] = useState();
  const [applicationName, setApplicationName] = useState('');

  const location = useLocation();
  const history = useHistory();
  const [isBreadcrumb, setBreadcrumb] = useState(
    [
      {
        name: 'My Application',
        link: '/my-application',
      },
      {
        name: 'Details App',
        link: '',
      },
    ]
  );

  useEffect(()=>{
    (async () => {
      // get user
      const currUser = authSvc.currentUser();
      const userData = await userSvc.get(currUser?.user?.id);
      setUser(userData?.data?.data);
    })();
  }, [])

  useEffect(() => {
    getDataById(location?.state?.id);
  }, [location]);

   // Integration
   const getDataById = async (id) => {
    setLoading(true);
    try {
      const applicationData = await applicationSvc.getById(id);
      setDataDetail(applicationData?.data?.data || []);
      setApplicationName(applicationData?.data?.data?.application_name)
      isBreadcrumb[1].name = applicationData?.data?.data?.application_name;
      setBreadcrumb(isBreadcrumb)
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  
  const handleEdit = async () => {
    setLoading(true);
    const { id: userId, organization } = user;
    const channels = [];

    const foundChannelWhatsapp = isDataDetail.channels.find((item) => item.channel === channelConstant.whatsapp);
    if (foundChannelWhatsapp) {
      const foundChannel = isDataDetail.channels.find((item) => item.channel === channelConstant.whatsapp);
      channels.push({
        _id: foundChannel?.id || foundChannel?._id || null,
        channel: channelConstant.whatsapp,
        senderImageUrl: "",
        senderName: "",
      });
    }
    const foundChannelSMS = isDataDetail.channels.find((item) => item.channel === channelConstant.sms);
    if (foundChannelSMS) {
      const foundChannel = isDataDetail.channels.find((item) => item.channel === channelConstant.sms);
      channels.push({
        _id: foundChannel?.id || foundChannel?._id || null,
        channel: channelConstant.sms,
        senderName: "",
        senderNumber: "",
      });
    }
    const foundChannelCall = isDataDetail.channels.find((item) => item.channel === channelConstant.call);
    if (foundChannelCall) {
      const foundChannel = isDataDetail.channels.find((item) => item.channel === channelConstant.call);
      channels.push({
         _id: foundChannel?.id || foundChannel?._id || null,
        channel: channelConstant.call,
      });
    }
    const foundChannelEmail = isDataDetail.channels.find((item) => item.channel === channelConstant.email);
    if (foundChannelEmail) {
      const foundChannel = isDataDetail.channels.find((item) => item.channel === channelConstant.email);
      channels.push({
         _id: foundChannel?.id || foundChannel?._id || null,
        channel: channelConstant.email,
      });
    }
    const foundChannelOTPSMS = isDataDetail.channels.find((item) => item.channel === channelConstant.smsOtp);
    if (foundChannelOTPSMS) {
      const foundChannel = isDataDetail.channels.find((item) => item.channel === channelConstant.smsOtp);
      channels.push({
         _id: foundChannel?.id || foundChannel?._id || null,
        channel: channelConstant.smsOtp,
      });
    }

    const bodyData = {
      userId,
      organizationId: organization,
      applicationName,
    };

    try {
      await applicationSvc.update(location?.state?.id, { ...bodyData, channels });

      setLoading(false);
      Alert.showStatus(
        'success',
        'Success edit application',
        'Application has been successfully updated!'
      )
      history.push({
        pathname: "/my-application",
      });
    } catch (err) {
      setLoading(false);
    }
  }

  // async function onGenerateKey(){
  //   SetLoadingGenerate(true)
  //   try {
  //     const privateKey = await applicationSvc.generatePem(location?.state?._id);
  //     downloadPem(privateKey.data, location?.state?._id);
  //     Alert.showStatus(
  //       'success',
  //       'Success Generate Token!',
  //       'A new token, has been successfully generated!'
  //     )
  //     SetLoadingGenerate(false)
  //   } catch (err) {
  //     Alert.showStatus(
  //       'error',
  //       'Error',
  //       err?.message
  //     )
  //     SetLoadingGenerate(false)
  //   }
  // }

  // const downloadPem = (text, appId) => {
  //   const element = document.createElement("a");
  //   const file = new Blob([text], { type: 'text/plain' });
  //   element.href = URL.createObjectURL(file);
  //   element.download = `${appId}.txt`;
  //   document.body.appendChild(element); // Required for this to work in FireFox
  //   element.click();
  // }
  
  return (
    <div className='container_detail_application'>
      <div className='wrapper_title mb-4'>
        <h3 className='title_custom_700'>Edit App</h3>
        <div className='d-flex align-items-center w-100'>
          <BreadCrumb dataBreadCrumb={isBreadcrumb} />
          <div className='d-flex align-items-center fsize-14 fweight-500 cl-grey-deep ms-2'>
            <span>Last Modified :</span> 
            <span className='ms-2'> 
              {moment(isDataDetail?.updated_at).format('DD MMMM YYYY')}
            </span>
          </div>
        </div>
      </div>
      <form>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <div className='form-group'>
              <label className='fsize-16 fweight-600 cl-neutral400 d-block ltr-spaccing-2'>Application Name</label>
              <label className='fsize-14 fweight-400 cl-neutral400 ltr-spaccing-2'>Give a friendly identifier to your application.</label>
              <TextInput 
                className='cl-neutral600 fsize-14 fweight-400 mb-1'
                placeholder="E.g. Omni Communication Assistant"
                value={applicationName}
                onChange={(event) => setApplicationName(event.target.value)}
              />
            </div>
          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='form-group'>
              <label className='fsize-16 fweight-600 cl-neutral400 d-block ltr-spaccing-2'>App ID</label>
              <label className='fsize-14 fweight-400 cl-neutral400 ltr-spaccing-2'>Your own App ID, as an identifier.</label>
              <TextInput 
                className='cl-neutral600 fsize-14 fweight-400 mb-1'
                value={isDataDetail?._id}
                disabled
              />
            </div>
          </div>
        </div>
        <button 
          disabled={isLoading || !applicationName} 
          onClick={handleEdit} 
          type="button" 
          className={`btn-primary-custom px-5 mt-2 ltr-spaccing-2 ms-auto ${isLoading && 'loading_active'}`}>
            Save Changes
          {isLoading && (
            <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true" />
          )}
        </button>
      </form>
      <Divider className="margin-bottom-15" />
      {/* <div className='auth_token mb-4'>
        <div className='form-group'>
          <label className='fsize-16 fweight-600 cl-neutral400 d-block mb-1 ltr-spaccing-2'>Authentication</label>
          <label className='fsize-14 fweight-400 cl-neutral400 mb-2 ltr-spaccing-2'>
            OCA APIs (Voice, Messages, Conversation, etc.) use JSON Web Tokens (JWTs) for authentication.
            <br />
            The JWTs must be signed with the private key of this application, you can provide your keys, or we can generate them for you.
          </label>
          <button disabled={loadingGenerate} onClick={onGenerateKey} type="button" className={`btn-primary-custom px-5 mt-2 ltr-spaccing-2 ${loadingGenerate && 'loading_active'}`}>
            Generate Access Token
            {loadingGenerate && (
              <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true" />
            )}
          </button>
        </div>
      </div> */}
      {/* <div className='wrapper_table_detail_app'>
        <h3 className='fsize-16 fweight-600 cl-neutral400 d-block ltr-spaccing-2 mb-3'>Link to channels </h3>
        <div>
          <Table 
            isLoadingGetList={isLoadingGetList} 
            isDataUser={isDataUser}
          />
        </div>
        <span className='cl-grey fweight-400'>
          You can set up your channel’s accounts on 
          <Link to='/management-channel' className='cl-red cursor-pointer text-decoration-none ms-1'>
            Channel Management
          </Link>
        </span>
      </div> */}
    </div>
  )
}

export default EditAppNew